/** @format */

import React, { useContext, useEffect, useState } from "react";
import "./index.scss";
import Select from "react-select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import {
  TICKET_SEVERITY,
  TICKET_STAGES,
  EXTENDED_TECH_SUPPORT_OPTIONS,
  USER_LIMITS,
} from "../../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import { HTTP_METHODS, invokeApi } from "../../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../../utils/endpoints";
import {
  BASIC_INFO_FORM_CONFIG2,
  FINAL_ACTION_LIST,
  REASONS_FOR_ENGINE_REPLACEMENT,
} from "./helper";
import RowRadioButtonsGroup from "../../../core/radio-group";
import SiFileUpload from "../../../core/file-uploader";
import { toast } from "react-toastify";
import SiTextField from "../../../core/si-textfield";
import SiDropdown from "../../../core/si-dropdown";
import SiAutocomplete from "../../../core/si-autocomplete";
import FormGenerator from "../../../core/form-generator";
import { checkForUserLimit } from "../../../utils";
import AppContext from "../../../utils/context";
import CustomButtonComponent from "../../../core/custom-button";

const FormDetails = ({
  loadData,
  ticketDetails = {},
  codes,
  parts,
  serviceEngineers,
  complaintForm = {},
}) => {
  const { id } = useParams();
  const [engineer, setEngineer] = useState({});
  const [defectCode, setDefectCode] = useState({});
  const [engineNo, setEngineNo] = useState("");
  const [engineModal, setEngineModal] = useState("");
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [invoiceNumber, setInvoiceNumber] = useState(null);
  const [plant, setPlant] = useState(ticketDetails?.plant || "");
  const [listNumber, setListNumber] = useState(ticketDetails?.listNumber || "");

  const [engineReplacementPayload, setEngineReplacementPayload] = useState({
    replacementBy: "",
    engineType: "",
    engineTypeValue: null,
    extraText: "",
    mode: "",
  });
  const [formData2, setFormData2] = useState({});
  const [errors, setErrors] = useState({});
  const [partReplacementPayload, setPartReplacementPayload] = useState({
    mode: "",
    scope: "",
    listOfParts: [],
    extra: "",
  });
  const [files, setFiles] = useState([]);
  const { userDetails = {} } = useContext(AppContext);
  const navigate = useNavigate();
  const updateEngineDetails = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.ENTER_ENGINE_DETAILS}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };

  const assignEngineer = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.ASSIGN_SE}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error(response.message);
        } else {
          setEngineer({});
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const addComments = (payload) => {
    invokeApi(HTTP_METHODS.POST, `${HOSTNAME}${REST_URLS.COMMENT}/${id}`, {
      ...payload,
    })
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const updateActionCodeSubmitHandler = (type) => {
    let payload = {
      code: defectCode.value,
      type: type,
    };
    if (defectCode.label === "A002") {
      payload["engineReplacementInfo"] = engineReplacementPayload;
    }
    if (defectCode.label === "A003") {
      // const listOfParts = partReplacementPayload.listOfParts.map(
      //   (l) => l.label
      // );
      const listOfParts = partReplacementPayload.listOfParts.map((l) => ({
        part: l.label,
        cost: l.cost,
      }));
      payload["partsReplacementInfo"] = {
        ...partReplacementPayload,
        listOfParts,
      };
    }
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.UPDATE_ACTION_CODE}/${id}`,
      payload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setDefectCode({});
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const updateDefectCode = (type) => {
    invokeApi(HTTP_METHODS.PUT, `${HOSTNAME}${REST_URLS.DEFECT_ACTION}/${id}`, {
      dc: defectCode.value,
    })
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setDefectCode({});
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };

  const updateOutOfWarranty = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.OUT_OF_WARRANTY}/${id}`,
      {
        action: "EXTENDED_TECH_SUPPORT",
        value: defectCode.value,
        comment: "",
        attachment: "",
      }
    )
      .then((response) => {
        setDefectCode({});
        loadData();
      })
      .catch((err) => console.error(err));
  };

  const updateActionCode = () => {
    if (defectCode.code === "A002") {
      engineReplacement();
    } else if (defectCode.code === "A003") {
      partReplacement();
    }
    updateActionCodeSubmitHandler("action");
  };
  const engineReplacement = () => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.A002_ACTION}/${id}`,
      engineReplacementPayload
    )
      .then((response) => {
        if (response.message) {
          toast.error(response.message);
        } else {
          setEngineReplacementPayload({
            replacementBy: "",
            engineType: "",
            engineTypeValue: null,
            extraText: "",
            mode: "",
          });
        }
      })
      .catch((err) => console.error(err));
  };

  const partReplacement = () => {
    let payload = partReplacementPayload;
    payload.listOfParts = partReplacementPayload.listOfParts.map(
      (l) => l.description
    );
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.A003_ACTION}/${id}`,
      payload
    )
      .then((response) => {
        setPartReplacementPayload({
          mode: "",
          scope: "",
          listOfParts: [],
          extra: "",
        });
      })
      .catch((err) => console.error(err));
  };

  const getActionCode002Elements = () => {
    return (
      <div>
        <RowRadioButtonsGroup
          label="Replacement Mode"
          options={["under_warranty", "goodwill_warranty"]}
          value={engineReplacementPayload.mode}
          onChange={(event) => {
            setEngineReplacementPayload({
              ...engineReplacementPayload,
              mode: event.target.value,
            });
          }}
        />
        <RowRadioButtonsGroup
          label="Replacement By"
          options={["simpsons", "oem"]}
          value={engineReplacementPayload.replacementBy}
          onChange={(event) => {
            setEngineReplacementPayload({
              ...engineReplacementPayload,
              replacementBy: event.target.value,
            });
          }}
        />
        {engineReplacementPayload.replacementBy === "simpsons" && (
          <RowRadioButtonsGroup
            label="Engine Type"
            options={["new_engine", "float_engine"]}
            value={engineReplacementPayload.engineType}
            onChange={(event) => {
              setEngineReplacementPayload({
                ...engineReplacementPayload,
                engineType: event.target.value,
              });
            }}
          />
        )}
        {engineReplacementPayload.replacementBy === "oem" && (
          <RowRadioButtonsGroup
            label="Engine Type"
            options={["from_oem_plant", "through_spd_mode", "from_oem_deposit"]}
            value={engineReplacementPayload.engineType}
            onChange={(event) => {
              setEngineReplacementPayload({
                ...engineReplacementPayload,
                engineType: event.target.value,
              });
            }}
          />
        )}
        {engineReplacementPayload.engineType &&
          engineReplacementPayload.engineTypeValue !== "float_engine" &&
          REASONS_FOR_ENGINE_REPLACEMENT[
            engineReplacementPayload.engineType
          ] && (
            <RowRadioButtonsGroup
              label="Reason for engine replacement"
              options={
                REASONS_FOR_ENGINE_REPLACEMENT[
                  engineReplacementPayload.engineType
                ]
              }
              value={engineReplacementPayload.engineTypeValue}
              onChange={(event) => {
                setEngineReplacementPayload({
                  ...engineReplacementPayload,
                  engineTypeValue: event.target.value,
                });
              }}
            />
          )}

        {engineReplacementPayload.engineType === "float_engine" ||
          (engineReplacementPayload.engineType === "from_oem_deposit" && (
            <div>
              <p>Replacement engine Sl. No</p>
              <SiTextField
                sx={{ width: "95%" }}
                size="small"
                value={engineReplacementPayload.engineTypeValue}
                onChange={(event) => {
                  setEngineReplacementPayload({
                    ...engineReplacementPayload,
                    engineTypeValue: event.target.value,
                  });
                }}
                placeholder="Replacement engine Sl. No"
              />
            </div>
          ))}

        {engineReplacementPayload.engineType && (
          <div>
            <p>Extra info</p>
            <SiTextField
              value={engineReplacementPayload.extraText}
              onChange={(event) => {
                setEngineReplacementPayload({
                  ...engineReplacementPayload,
                  extraText: event.target.value,
                });
              }}
              placeholder="Extra Info"
              sx={{ width: "95%" }}
            />
          </div>
        )}

        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}>
          <CustomButtonComponent
            variant="contained"
            color="success"
            size="small"
            disabled={!defectCode.value}
            onClick={updateActionCode}
            sx={{ width: "150px" }}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    );
  };

  const getActionCode003Elements = () => {
    return (
      <div>
        <RowRadioButtonsGroup
          label="Replacement Mode"
          options={["under_warranty", "goodwill_warranty"]}
          value={partReplacementPayload.mode}
          onChange={(event) => {
            setPartReplacementPayload({
              ...partReplacementPayload,
              mode: event.target.value,
            });
          }}
        />
        <RowRadioButtonsGroup
          label="Scope"
          options={["simpsons", "oem"]}
          value={partReplacementPayload.scope}
          onChange={(event) => {
            setPartReplacementPayload({
              ...partReplacementPayload,
              scope: event.target.value,
            });
          }}
        />

        <div style={{ width: "95%" }}>
          <p>Parts list</p>
          <SiAutocomplete
            multiple
            value={partReplacementPayload.listOfParts}
            options={parts}
            placeholder="Parts List"
            getOptionLabel={(option) => option.part || option.label || ""}
            onChange={(newValue) => {
              const updatedList = newValue?.map((item) => ({
                ...item,
                cost: item.cost || "",
              }));
              setPartReplacementPayload({
                ...partReplacementPayload,
                listOfParts: updatedList,
              });
            }}
          />

          {partReplacementPayload?.listOfParts?.map((part, index) => (
            <Box
              key={index}
              sx={{ display: "flex", alignItems: "center", gap: 2, mt: 1 }}
            >
              <p style={{ minWidth: 100 }}>{part.part || part.label}</p>
              <SiTextField
                type="number"
                value={part.cost}
                onChange={(e) => {
                  const updatedList = [...partReplacementPayload.listOfParts];
                  updatedList[index].cost = parseFloat(e.target.value) || "";
                  setPartReplacementPayload({
                    ...partReplacementPayload,
                    listOfParts: updatedList,
                  });
                }}
                placeholder="Cost"
              />
            </Box>
          ))}
        </div>

        <div>
          <p>Extra info</p>
          <SiTextField
            value={partReplacementPayload.extra}
            onChange={(event) => {
              setPartReplacementPayload({
                ...partReplacementPayload,
                extra: event.target.value,
              });
            }}
            placeholder="Extra Info"
            sx={{ width: "95%" }}
          />
          {/* <TextField
            fullWidth
            size="small"
            value={partReplacementPayload.extra}
            onChange={(event) => {
              setPartReplacementPayload({
                ...partReplacementPayload,
                extra: event.target.value,
              });
            }}
          /> */}
        </div>
        <Box sx={{ display: "flex", justifyContent: "center", mb: 2, mt: 2 }}>
          <CustomButtonComponent
            fullWidth
            variant="contained"
            color="success"
            disabled={!defectCode.value}
            onClick={updateActionCode}
            sx={{ width: "150px" }}
          >
            Submit
          </CustomButtonComponent>
        </Box>
      </div>
    );
  };
  const callBack = (newFile) => {
    setFiles([...files, newFile]);
  };

  const getStageForm = () => {
    switch (ticketDetails.stage) {
      case TICKET_STAGES.ASSIGN_SE:
        return (
          <>
            <div>
              <FormGenerator
                config={BASIC_INFO_FORM_CONFIG2(serviceEngineers, formData2)}
                formData={formData2}
                setFormData={setFormData2}
                errors={errors}
                setErrors={setErrors}
              />
            </div>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <SiFileUpload id={id} callBack={callBack} />
              <CustomButtonComponent
                variant="contained"
                color="success"
                size="small"
                disabled={!formData2?.engineer?.value}
                onClick={() => {
                  const payload = {
                    serviceEngineerId: formData2?.engineer?.value,
                    additionalServiceEngineer:
                      formData2?.additionalServiceEngineer?.value,
                    expertise: formData2?.expertise?.value,
                  };

                  assignEngineer(payload);
                  if (formData2.comment) {
                    addComments({ comment: formData2.comment });
                  }
                }}
                sx={{ width: "150px", ml: 2 }}
              >
                Submit
              </CustomButtonComponent>
            </Box>
          </>
        );
      case TICKET_STAGES.ENTER_ENGINE_DETAILS:
        if (checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)) {
          return (
            <>
              <Grid container>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> Engine Number</p>
                    <SiTextField
                      value={complaintForm?.engineSerialNumber || ""}
                      onChange={(e) => setEngineNo(e.target.value)}
                      placeholder="Engine Number"
                      disabled
                    />
                  </div>
                </Grid>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> Engine model</p>
                    <SiTextField
                      value={engineModal}
                      onChange={(e) => setEngineModal(e.target.value)}
                      placeholder="Engine Model"
                    />
                  </div>
                </Grid>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> Invoice Date</p>
                    <SiTextField
                      value={invoiceDate}
                      onChange={(e) => setInvoiceDate(e.target.value)}
                      type="date"
                    />
                  </div>
                </Grid>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> Invoice Number</p>
                    <SiTextField
                      value={invoiceNumber}
                      onChange={(e) => setInvoiceNumber(e.target.value)}
                      placeholder="Invoice Number"
                    />
                  </div>
                </Grid>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> Plant</p>
                    <SiTextField
                      value={plant}
                      onChange={(e) => setPlant(e.target.value)}
                      placeholder="Plant"
                      disabled={ticketDetails?.plant}
                    />
                  </div>
                </Grid>
                <Grid item md={3} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
                  <div>
                    <p> List Number</p>
                    <SiTextField
                      value={listNumber}
                      onChange={(e) => setListNumber(e.target.value)}
                      placeholder="List Number"
                      disabled={ticketDetails?.listNumber}
                    />
                  </div>
                </Grid>
              </Grid>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "20px",
                }}
              >
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  size="small"
                  disabled={
                    !engineModal ||
                    !invoiceDate ||
                    !invoiceNumber ||
                    !plant ||
                    !listNumber
                  }
                  onClick={() => {
                    updateEngineDetails({
                      invoiceDate,
                      engineModal,
                      invoiceNumber,
                      plant,
                      listNumber,
                    });
                  }}
                  sx={{ width: "150px", mt: 2, mb: 2 }}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            </>
          );
        }
        break;
      case TICKET_STAGES.UPDATE_DEFECT_CODE:
        if (
          checkForUserLimit(USER_LIMITS.SERVICE_ENGINEER, userDetails.limits) ||
          checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)
        ) {
          return (
            <>
              <div
                style={{
                  width: "95%",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <SiAutocomplete
                  options={codes}
                  value={(defectCode.value && defectCode) || ""}
                  placeholder="Select Defect Code"
                  optionLabel="placeholder"
                  onChange={(val) => {
                    if (val) {
                      setDefectCode(val);
                    } else {
                      setDefectCode({});
                    }
                  }}
                />
              </div>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  disabled={!defectCode.value}
                  onClick={() => updateDefectCode("defect")}
                  sx={{ width: "150px" }}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            </>
          );
        }
        break;
      // case TICKET_STAGES.ENGINE_REPLACEMENT_REJECTED:
      //   if (
      //     checkForUserLimit(USER_LIMITS.SERVICE_ENGINEER, userDetails.limits) ||
      //     checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)
      //   ) {
      //     return (
      //       <>
      //         <div
      //           style={{
      //             width: "95%",
      //             marginTop: "20px",
      //             marginBottom: "20px",
      //           }}
      //         >
      //           <SiAutocomplete
      //             options={codes}
      //             value={(defectCode.value && defectCode) || ""}
      //             onChange={(value) => setDefectCode(value)}
      //             placeholder="Select Defect Code"
      //           />
      //         </div>

      //         <Box sx={{ display: "flex", justifyContent: "center" }}>
      //           <CustomButtonComponent
      //             variant="contained"
      //             color="success"
      //             disabled={!defectCode.value}
      //             onClick={() => updateDefectCode("defect")}
      //             sx={{ width: "150px" }}
      //           >
      //             Submit
      //           </CustomButtonComponent>
      //         </Box>
      //       </>
      //     );
      //   }
      //   break;
      case TICKET_STAGES.JIR_CREATED:
        if (
          checkForUserLimit(USER_LIMITS.SERVICE_ENGINEER, userDetails.limits) ||
          checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)
        ) {
          return (
            <>
              <div
                style={{
                  width: "95%",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <SiAutocomplete
                  options={codes}
                  value={(defectCode.value && defectCode) || ""}
                  onChange={(val) => {
                    if (val) {
                      setDefectCode(val);
                    } else {
                      setDefectCode({});
                    }
                  }}
                  placeholder="Select Defect Code"
                  optionLabel="placeholder"
                />
              </div>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  disabled={!defectCode.value}
                  onClick={() => updateDefectCode("defect")}
                  sx={{ width: "150px" }}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            </>
          );
        }
        break;

      case TICKET_STAGES.UPDATE_ACTION_CODE:
        if (
          checkForUserLimit(USER_LIMITS.SERVICE_ENGINEER, userDetails.limits) ||
          checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)
        ) {
          return (
            <>
              <div
                style={{
                  width: "95%",
                  marginTop: "20px",
                  marginBottom: "20px",
                }}
              >
                <SiAutocomplete
                  options={codes}
                  value={(defectCode?.value && defectCode) || ""}
                  onChange={(val) => {
                    if (val) {
                      setDefectCode(val);
                    } else {
                      setDefectCode({});
                    }
                  }}
                  placeholder="Select Action Code"
                  optionLabel="placeholder"
                />
              </div>
              {defectCode.label === "A002" && getActionCode002Elements()}
              {defectCode.label === "A003" && getActionCode003Elements()}

              {defectCode.label !== "A002" && defectCode.label !== "A003" && (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <CustomButtonComponent
                    variant="contained"
                    color="success"
                    disabled={!defectCode.value}
                    onClick={() => updateActionCodeSubmitHandler("action")}
                    sx={{ width: "150px" }}
                  >
                    Submit
                  </CustomButtonComponent>
                </Box>
              )}
            </>
          );
        }
        break;
      case TICKET_STAGES.OUT_OF_WARRANTY:
        if (ticketDetails.status !== "CLOSED") {
          return (
            <>
              <div style={{ width: "95%", marginTop: "20px" }}>
                <SiAutocomplete
                  options={EXTENDED_TECH_SUPPORT_OPTIONS}
                  value={(defectCode?.label && defectCode) || null}
                  onChange={(value) => setDefectCode(value)}
                  placeholder="Extent tech support"
                />
              </div>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <CustomButtonComponent
                  variant="contained"
                  color="success"
                  size="small"
                  disabled={!defectCode?.label}
                  onClick={() => updateOutOfWarranty()}
                  sx={{ width: "150px", mb: 2, mt: 2 }}
                >
                  Submit
                </CustomButtonComponent>
              </Box>
            </>
          );
        }
        break;
    }
  };
  const updateTicket = (payload) => {
    invokeApi(
      HTTP_METHODS.PUT,
      `${HOSTNAME}${REST_URLS.TICKETS}/${id}`,
      payload
    )
      .then((response) => {
        if (response?.message) {
          toast.error("Update Failed");
        } else {
          loadData();
        }
      })
      .catch((err) => console.error(err));
  };
  const getEngineModel = () => {
    if (checkForUserLimit(USER_LIMITS.ADMIN, userDetails.limits)) {
      return (
        <>
          <Typography color="error" sx={{ fontWeight: 600 }}>
            Disclaimer: Engine Model is Required.
          </Typography>
          <Grid container>
            <Grid item md={6} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
              <div>
                <p> Engine Number</p>
                <SiTextField
                  value={complaintForm?.engineSerialNumber || ""}
                  onChange={(e) => setEngineNo(e.target.value)}
                  placeholder="Engine Number"
                  disabled
                />
              </div>
            </Grid>
            <Grid item md={6} sx={{ pr: { md: 3, xs: 0, sm: 0 } }}>
              <div>
                <p> Engine model</p>
                <SiTextField
                  value={engineModal}
                  onChange={(e) => setEngineModal(e.target.value)}
                  placeholder="Engine Model"
                />
              </div>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <CustomButtonComponent
              variant="contained"
              color="success"
              size="small"
              disabled={!engineModal}
              onClick={() => {
                updateTicket({
                  engineModal,
                });
              }}
              sx={{ width: "150px", mt: 2, mb: 2 }}
            >
              Submit
            </CustomButtonComponent>
          </Box>
        </>
      );
    }
  };
  useEffect(() => {
    setPlant(ticketDetails?.plant || "");
    setListNumber(ticketDetails?.listNumber || "");
  }, [ticketDetails]);
  return (
    <div className="load-page">
      {getStageForm() && (
        <div className="form-con">
          <div className="form-header"> Action to be taken</div>
          <div className="action-form">
            {ticketDetails.stage !== TICKET_STAGES.ENTER_ENGINE_DETAILS &&
            !ticketDetails?.engineModal
              ? getEngineModel()
              : getStageForm()}
          </div>
        </div>
      )}
    </div>
  );
};

export default FormDetails;
